import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {InfoDetail} from "./style";
import { isZhaiquanCategory } from '../../../utils/tool';

export default class Detail extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  listPriceHandler(lowerLimit, upperLimit) {
    let retPrice = '欢迎询价';
    if (lowerLimit && upperLimit) {
      if(lowerLimit!==upperLimit){
        retPrice = `¥${lowerLimit}-¥${upperLimit}`;
      }else{
        retPrice = `¥${lowerLimit}`;
      }
    } else if (lowerLimit && !upperLimit) {
      retPrice = `¥${lowerLimit}以上`
    } else if (upperLimit && !lowerLimit) {
      retPrice = `¥${upperLimit}以下`
    }
    return retPrice;
  }

  formatPrice(price) {
    let priceFormatted = ''
    if (price === 0) priceFormatted = '0'
    if (price) {
      if (price >= 100000000) {
        // 转换为亿元,最多保留小数点后四位
        priceFormatted = (Math.floor(price / 10000) / 10000).toString() + '亿'
      } else if (price >= 10000) {
        // 转换为万元，最多保留小数点后两位
        priceFormatted = (Math.floor(price / 100) / 100).toString() + '万'
      } else {
        priceFormatted = price.toString()
      }
    }
    return priceFormatted
  }

  render() {
    const {templateType, creditTotalCharges, referenceLowerLimit, referenceUpperLimit,categoryName,onlookersNum,intendedPersonNum} = this.props.itemInfo;
    const displayCreditPrice = this.formatPrice(creditTotalCharges);
    const displayReferencePrice = this.listPriceHandler(this.formatPrice(referenceLowerLimit), this.formatPrice(referenceUpperLimit));
    return (
      <InfoDetail>
        <div className="p-middle">
          {isZhaiquanCategory(templateType) ?
            <p className="p-price">
              债权总额
              <span className={`price-num ${(`${displayCreditPrice}`).length > 9 || (!displayCreditPrice) ? 'price-small' : ''}`}>
                {displayCreditPrice ? `¥ ${displayCreditPrice}` : `欢迎询价`}</span>
            </p>
            :
            <p className="p-price">
              参考价值
              <span className={`price-num ${displayReferencePrice.length > 9 || displayReferencePrice === '欢迎询价' ? 'price-small' : ''}`}>
                {displayReferencePrice}</span>
            </p>
          }
          <p className="p-category">资产类型<i> {categoryName}</i></p>
        </div>
        <p className="p-bid"><i>{intendedPersonNum}</i>名意向人<span className="p-bid-divide"></span><i>{onlookersNum}</i>次围观</p>
      </InfoDetail>
    )
  }
}
